import { pickComponentHelper } from '@quintype/framework/server/pick-component-helper';
import { PAGE_TYPE } from './constants';

const { pickComponent, getChunkName } = pickComponentHelper(
  {
    [PAGE_TYPE.HOME_PAGE]: { chunk: 'home', component: 'HomePage' },
    [PAGE_TYPE.HOME_PAGE_TEST]: { chunk: 'home', component: 'HomePageTest' },
    [PAGE_TYPE.SECTION_PAGE_TEST]: { chunk: 'section', component: 'SectionPageTest' },
    [PAGE_TYPE.STORY_PAGE_TEST]: { chunk: 'story', component: 'StoryPageTest' },
    [PAGE_TYPE.STORY_PAGE_PROMOTIONAL_AD]: { chunk: 'story', component: 'StoryPageTest' },
    [PAGE_TYPE.VIDEO_PAGE_TEST]: { chunk: 'story', component: 'StoryPageTest' },
    [PAGE_TYPE.SEARCH_PAGE_TEST]: { chunk: 'list', component: 'SearchPage' },
    [PAGE_TYPE.SECTION_PAGE]: { chunk: 'section', component: 'SectionPage' },
    [PAGE_TYPE.VIDEOS_PAGE]: { chunk: 'videos', component: 'VideosPage' },
    [PAGE_TYPE.LIVETV_PAGE]: { chunk: 'livetv', component: 'LiveTVPage' },
    [PAGE_TYPE.PODCAST_PAGE]: { chunk: 'podcast', component: 'PodcastPage' },
    [PAGE_TYPE.EPISODE_PAGE]: { chunk: 'podcast', component: 'EpisodePage' },
    [PAGE_TYPE.IPOS_TRACKER]: { chunk: 'ipotracker', component: 'IposTracker' },
    [PAGE_TYPE.TAG_PAGE]: { chunk: 'tag', component: 'TagPage' },
    [PAGE_TYPE.AUTHOR_PAGE]: { chunk: 'list', component: 'AuthorPage' },
    [PAGE_TYPE.AUTHORS_PAGE]: { chunk: 'list', component: 'AuthorsPage' },
    [PAGE_TYPE.SEARCH_PAGE]: { chunk: 'search', component: 'SearchPage' },
    [PAGE_TYPE.STORY_PAGE]: { chunk: 'story', component: 'StoryPage' },
    [PAGE_TYPE.PLAYLIST_PAGE]: { chunk: 'videos', component: 'PlaylistPage' },
    [PAGE_TYPE.STORY_PREVIEW]: { chunk: 'story', component: 'StoryPagePreview' },
    [PAGE_TYPE.STORY_PUBLIC_PREVIEW_PAGE]: { chunk: 'story', component: 'StoryPublicPreview' },
    [PAGE_TYPE.HOME_PREVIEW]: { chunk: 'home', component: 'HomePagePreview' },
    [PAGE_TYPE.SUBSCRIPTION_PAGE]: { chunk: 'subscribe', component: 'SubscriptionPage' },
    [PAGE_TYPE.CHURN_USER_PAGE]: { chunk: 'subscribe', component: 'ChurnUserPage' },
    [PAGE_TYPE.SUBSCRIPTION_OFFER_PAGE]: { chunk: 'subscribe', component: 'SubscriptionOfferPage' },
    [PAGE_TYPE.VERIFY_EMAIL_PAGE]: { chunk: 'subscribe', component: 'VerifyEmailPage' },
    [PAGE_TYPE.BREAKOUT_ALERTS_PAGE]: { chunk: 'list', component: 'BreakoutAlerts' },
    [PAGE_TYPE.MYBQ_PAGE]: { chunk: 'portfolio', component: 'MyAccountPage' },
    [PAGE_TYPE.AMP_LOGIN]: { chunk: 'story', component: 'AmpLogin' },
    [PAGE_TYPE.SITEMAP_PAGE]: { chunk: 'sitemap', component: 'Sitemap' },
    [PAGE_TYPE.SECTION_VIDEO_PAGE]: { chunk: 'videos', component: 'SectionVideoPage' },
    [PAGE_TYPE.NOT_FOUND]: { chunk: 'notfound', component: 'NotFoundPage' },
    [PAGE_TYPE.MARKET_PAGE]: { chunk: 'market', component: 'MarketPage' },
    [PAGE_TYPE.STOCK_PAGE]: { chunk: 'market', component: 'StockPage' },
    [PAGE_TYPE.INDIAN_INDICES_PAGE]: { chunk: 'market', component: 'IndianIndicesExternalPage' },
    [PAGE_TYPE.SECTORAL_INDICES_PAGE]: {
      chunk: 'market',
      component: 'SectoralIndicesExternalPage',
    },
    [PAGE_TYPE.CORPORATE_ACTIONS_PAGE]: {
      chunk: 'market',
      component: 'CorporateActionsExternalPage',
    },
    [PAGE_TYPE.HISTORICAL_RETURNS_PAGE]: {
      chunk: 'market',
      component: 'HistoricalReturnsExternalPage',
    },
    [PAGE_TYPE.STOCKS_IN_INDICES_PAGE]: {
      chunk: 'market',
      component: 'StocksInIndicesExternalPage',
    },
    [PAGE_TYPE.SECTORAL_STOCKS_IN_INDICES_PAGE]: {
      chunk: 'market',
      component: 'SectoralStocksInIndicesExternalPage',
    },
    [PAGE_TYPE.FUTURES_PAGE]: { chunk: 'market', component: 'FuturesPage' },
    [PAGE_TYPE.OPEN_INTEREST_PAGE]: { chunk: 'market', component: 'FuturesExternalOpenInterest' },
    [PAGE_TYPE.GREATEST_PREMIUM_PAGE]: {
      chunk: 'market',
      component: 'FuturesExternalGreatestPremium',
    },
    [PAGE_TYPE.FUTURES_ROLLOVER_PAGE]: { chunk: 'market', component: 'FuturesExternalRollover' },
    [PAGE_TYPE.FUTURES_SHORT_COVERING_PAGE]: {
      chunk: 'market',
      component: 'FuturesExternalShortCovering',
    },
    [PAGE_TYPE.FUTURES_MOST_ACTIVE_CONTRACTS_PAGE]: {
      chunk: 'market',
      component: 'FuturesExternalMostActiveContracts',
    },
    [PAGE_TYPE.FUTURES_SECTORAL_MOVEMENTS_PAGE]: {
      chunk: 'market',
      component: 'FuturesExternalSectoralMovements',
    },
    [PAGE_TYPE.FUTURES_FILTER_PAGE]: { chunk: 'market', component: 'FuturesExternalFiltered' },
    [PAGE_TYPE.OPTIONS_PAGE]: { chunk: 'market', component: 'OptionsPage' },
    [PAGE_TYPE.OPTIONS_MOST_ACTIVE_INDEX]: {
      chunk: 'market',
      component: 'OptionsExternalMostActiveIndex',
    },
    [PAGE_TYPE.OPTIONS_MOST_ACTIVE_STOCK]: {
      chunk: 'market',
      component: 'OptionsExternalMostActiveStock',
    },
    [PAGE_TYPE.OPTIONS_TOP_OPEN_INDEX]: {
      chunk: 'market',
      component: 'OptionsExternalTopOpenInterestIndex',
    },
    [PAGE_TYPE.OPTIONS_TOP_OPEN_STOCK]: {
      chunk: 'market',
      component: 'OptionsExternalTopOpenInterestStock',
    },
    [PAGE_TYPE.OPTIONS_OPEN_INTEREST_BREAKUP]: {
      chunk: 'market',
      component: 'OptionsExternalOpenInterestBreakup',
    },
    [PAGE_TYPE.OPTIONS_OPEN_INTEREST_CHANGE]: {
      chunk: 'market',
      component: 'OptionsExternalOpenInterestChange',
    },
    [PAGE_TYPE.OPTIONS_OI_LAST_EXPIRY]: {
      chunk: 'market',
      component: 'OptionsExternalOIChangeLastExpiry',
    },
    [PAGE_TYPE.OPTIONS_PUT_CALL_RATIO]: {
      chunk: 'market',
      component: 'OptionsExternalPutCallRatio',
    },
    default: { chunk: 'notfound', component: 'NotFoundPage' },
    [PAGE_TYPE.FEED_COUNTER_DASHBOARD]: { chunk: 'list', component: 'FeedCounterDashboard' },
    [PAGE_TYPE.EDITORIAL_CODE_OF_CONDUCT]: { chunk: 'list', component: 'EditorialCodeOfConduct' },

    // INDIVIDUAL MARKET WIDGETS
    [PAGE_TYPE.INDICES_WIDGET]: { chunk: 'widget', component: 'IndianIndicesWidget' },
    [PAGE_TYPE.FUTURES_GRAPH_WIDGET]: { chunk: 'widget', component: 'FuturesGraphWidget' },
    [PAGE_TYPE.MARKETS_NEWS_WIDGET]: { chunk: 'widget', component: 'MarketsNewsWidget' },
    [PAGE_TYPE.STOCK_STATS_WIDGET]: { chunk: 'widget', component: 'StockStatsWidget' },
    [PAGE_TYPE.SECTOR_INDICES_WITH_GRAPH_WIDGET]: {
      chunk: 'widget',
      component: 'SectorIndicesWithGraphWidget',
    },
    [PAGE_TYPE.TOP_SECTORS_WIDGET]: { chunk: 'widget', component: 'TopSectorsWidget' },
    [PAGE_TYPE.CALENDER_EVENTS_WIDGET]: { chunk: 'widget', component: 'CalenderEventsWidget' },

    // FULL PAGE WIDGETS
    [PAGE_TYPE.LIVE_TV_WIDGET]: { chunk: 'widget', component: 'LiveTvWidget' },
    [PAGE_TYPE.MARKETS_FULL_WIDGET]: { chunk: 'widget', component: 'MarketsFullWidget' },
    [PAGE_TYPE.STOCK_FULL_WIDGET]: { chunk: 'widget', component: 'StockFullWidget' },
    [PAGE_TYPE.FUTURES_CONTRACT_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'FuturesContractFullWidget',
    },
    [PAGE_TYPE.NDTV_MARKET_WIDGET]: { chunk: 'widget', component: 'NdtvMarketWidget' },
    [PAGE_TYPE.KEY_HIGHLIGHTS_WIDGET]: { chunk: 'widget', component: 'KeyHighlightsWidget' },
    [PAGE_TYPE.DAILYHUNT_MARKET_WIDGET]: { chunk: 'widget', component: 'NdtvMarketWidget' },
    [PAGE_TYPE.STOCKS_IN_FOCUS_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'StocksInFocusFullWidget',
    },
    [PAGE_TYPE.BUDGET_CALCULATOR_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'BudgetCalculatorFullWidget',
    },
    [PAGE_TYPE.STATE_OF_THE_ECONOMY_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'StateOfTheEconomyFullWidget',
    },
    [PAGE_TYPE.OPTIONS_CHAIN_FULL_WIDGET]: { chunk: 'widget', component: 'OptionChainFullWidget' },
    [PAGE_TYPE.EQ_ALL_FULL_WIDGET]: { chunk: 'widget', component: 'MarketsEqAllFullWidget' },
    [PAGE_TYPE.STOCK_IN_INDICES_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'StockIndicesFullWidget',
    },
    [PAGE_TYPE.HISTORICAL_RETURNS_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'HistoricalReturnsFullWidget',
    },
    [PAGE_TYPE.SECTORAL_INDICES_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'SectoralIndicesFullWidget',
    },
    [PAGE_TYPE.SECTORAL_STOCK_IN_INDICES_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'SectoralStockIndicesFullWidget',
    },
    [PAGE_TYPE.CALENDER_EVENTS_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'CalenderEventsFullWidget',
    },
    [PAGE_TYPE.SHORT_COVERING_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'ShortCoveringFullWidget',
    },
    [PAGE_TYPE.MOST_ACTIVE_CONTRACTS_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'MostActiveContractsFullWidget',
    },
    [PAGE_TYPE.SECTORAL_MOVEMENTS_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'SectoralMovementsFullWidget',
    },
    [PAGE_TYPE.MOST_ACTIVE_INDEX_OPTIONS_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'MostActiveIndexOptionsFullWidget',
    },
    [PAGE_TYPE.MOST_ACTIVE_STOCK_OPTIONS_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'MostActiveStockOptionsFullWidget',
    },
    [PAGE_TYPE.TOP_TEN_INT_INDEX_OPTIONS_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'TopTenIntIndexOptionsFullWidget',
    },
    [PAGE_TYPE.TOP_TEN_INT_STOCK_OPTIONS_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'TopTenIntIndexOptionsFullWidget',
    },
    [PAGE_TYPE.OPEN_INTEREST_BREAKUP_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'OpenInterestBreakupFullWidget',
    },
    [PAGE_TYPE.FUTURES_OI_CHANGE_SINCE_LAST_EXPIRY]: {
      chunk: 'widget',
      component: 'FuturesOIChangeSinceLastExpiryFullWidget',
    },
    [PAGE_TYPE.OPTIONS_OI_CHANGE_SINCE_LAST_EXPIRY]: {
      chunk: 'widget',
      component: 'OptionsOIChangeSinceLastExpiryFullWidget',
    },
    [PAGE_TYPE.PUT_CALL_RATIO_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'PutCallRatioFullWidget',
    },
    [PAGE_TYPE.TOPIC_FULL_WIDGET]: { chunk: 'widget', component: 'TopicFullWidget' },
    [PAGE_TYPE.GREATEST_PREMIUM_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'GreatestPremiumFullWidget',
    },
    [PAGE_TYPE.FUTURES_ROLLOVER_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'FuturesRolloverFullWidget',
    },
    [PAGE_TYPE.BUDGET_STOCKS_IN_FOCUS_LIVE]: {
      chunk: 'widget',
      component: 'StocksInFocusLiveFullWidget',
    },
    [PAGE_TYPE.OPEN_INTEREST_FULL_WIDGET]: { chunk: 'widget', component: 'OpenInterestFullWidget' },

    [PAGE_TYPE.ADVANCES_DECLINES_WIDGET]: { chunk: 'widget', component: 'AdvancesDeclinesWidget' },
    [PAGE_TYPE.BUDGET_IMPACT_WIDGET]: {
      chunk: 'widget',
      component: 'BudgetImpactFullWidget',
    },
    [PAGE_TYPE.BUDGET_PAGE]: { chunk: 'budget', component: 'BudgetPage' },
    [PAGE_TYPE.CALCULATORS]: { chunk: 'calculators', component: 'CalculatorListing' },
    [PAGE_TYPE.HOME_LOAN]: { chunk: 'calculators', component: 'HomeLoan' },
    [PAGE_TYPE.CAR_LOAN]: { chunk: 'calculators', component: 'CarLoan' },
    [PAGE_TYPE.EDUCATION_LOAN]: { chunk: 'calculators', component: 'EducationLoan' },
    [PAGE_TYPE.PERSONAL_LOAN]: { chunk: 'calculators', component: 'PersonalLoan' },
    [PAGE_TYPE.FIXED_DEPOSIT]: { chunk: 'calculators', component: 'FixedDeposit' },
    [PAGE_TYPE.RECURRING_DEPOSIT]: { chunk: 'calculators', component: 'RecurringDeposit' },
    [PAGE_TYPE.PUBLIC_PROVIDENT_FUND]: { chunk: 'calculators', component: 'PublicProvidentFund' },
    [PAGE_TYPE.SIP]: { chunk: 'calculators', component: 'Sip' },
    [PAGE_TYPE.INCOME_TAX]: { chunk: 'calculators', component: 'IncomeTax' },
    [PAGE_TYPE.BEEPS_PAGE]: { chunk: 'beeps', component: 'BeepsPage' },
    [PAGE_TYPE.BREAKOUT_ALERTS_WIDGET]: { chunk: 'widget', component: 'BreakoutAlertsWidget' },
    [PAGE_TYPE.BREAKOUT_ALERTS_FULL_WIDGET]: {
      chunk: 'widget',
      component: 'BreakoutAlertsFullWidget',
    },
    [PAGE_TYPE.BUDGET_REACTIONS_WIDGET]: {
      chunk: 'widget',
      component: 'BudgetReactionsFullWidget',
    },
    [PAGE_TYPE.ELECTIONS_WIDGET]: {
      chunk: 'widget',
      component: 'ElectionsWidget',
    },
  },
  {
    home: () => import(/* webpackChunkName: "home" */ './component-bundles/home.js'),
    story: () => import(/* webpackChunkName: "story" */ './component-bundles/story.js'),
    section: () => import(/* webpackChunkName: "section" */ './component-bundles/section.js'),
    list: () => import(/* webpackChunkName: "list" */ './component-bundles/list.js'),
    market: () => import(/* webpackChunkName: "market" */ './component-bundles/market.js'),
    videos: () => import(/* webpackChunkName: "videos" */ './component-bundles/videos.js'),
    livetv: () => import(/* webpackChunkName: "videos" */ './component-bundles/livetv.js'),
    subscribe: () => import(/* webpackChunkName: "subscribe" */ './component-bundles/subscribe.js'),
    podcast: () => import(/* webpackChunkName: "podcast" */ './component-bundles/podcast.js'),
    portfolio: () => import(/* webpackChunkName: "portfolio" */ './component-bundles/portfolio.js'),
    sitemap: () => import(/* webpackChunkName: "sitemap" */ './component-bundles/sitemap.js'),
    budget: () => import(/* webpackChunkName: "budget" */ './component-bundles/budget.js'),
    tag: () => import(/* webpackChunkName: "tag" */ './component-bundles/tag.js'),
    search: () => import(/* webpackChunkName: "search" */ './component-bundles/search.js'),
    notfound: () => import(/* webpackChunkName: "notfound" */ './component-bundles/notfound.js'),
    ipotracker: () =>
      import(/* webpackChunkName: "ipotracker" */ './component-bundles/ipotracker.js'),
    calculators: () =>
      import(/* webpackChunkName: "calculators" */ './component-bundles/calculators.js'),
    widget: () => import(/* webpackChunkName: "widget" */ './component-bundles/widget.js'),
    beeps: () => import(/* webpackChunkName: "beeps" */ './component-bundles/beeps.js'),
  },
);

export { getChunkName, pickComponent };
